import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'  // 引入组件库
import 'element-ui/lib/theme-chalk/index.css'  // 引入样式
import VueI18n from 'vue-i18n'  // 新增：导入VueI18n
import elementEnLocale from 'element-ui/lib/locale/lang/en';
 
// 先注册VueI18n，再注册ElementUI
Vue.use(VueI18n);
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)  // 关键：将ElementUI与i18n绑定
});
Vue.config.productionTip = false

// 定义语言包（合并Element UI的英文包）
const messages = {
  en: {
    ...elementEnLocale,  // 导入Element UI默认英文文案
    el: {
      pagination: {
        ...elementEnLocale.el.pagination,  // 继承原有配置
        total: 'Total {total} items',     // 覆盖总条数文案
        jumper: 'Go to page'               // 优化跳转文案（可选）
      }
    }
  }
};

// 创建i18n实例
const i18n = new VueI18n({
  locale: 'en', // 设置默认语言为英文
  messages,
});

new Vue({
  i18n,  // 注入i18n实例
  router,
  store,
  render: h => h(App)
}).$mount('#app')
